import { createSelector } from 'reselect';
import {
  LinkTypes,
  PromoterModel,
  PromoterTypes,
} from '../model/PromoterModel';
import { StoreState } from '../store-interfaces';
import { activeChatbotIdSelector } from './viewSelectors';

const selectPromoters = (state: StoreState) => state.promoter.entities || [];

const getPromoterByType = (promoters: PromoterModel[], type: LinkTypes) =>
  promoters.filter(p => p.type === type);

const selectPromoterType = (_, type: LinkTypes) => type;

const getPromoterById = (promoters: PromoterModel[], id: number) => {
  return promoters.find(p => p.id === id);
};

export const selectPromotersByBotId = createSelector(
  [selectPromoters, activeChatbotIdSelector],
  (promoters, activeChatbotId) =>
    promoters.filter(({ botId }) => botId === activeChatbotId),
);

export const selectCommentGuards = createSelector(
  [selectPromotersByBotId, _ => PromoterTypes.FB_COMMENT_GUARD],
  getPromoterByType,
);

export const selectFacebookatchAllEnagagements = createSelector(
  [selectPromotersByBotId, _ => PromoterTypes.FACEBOOK_CATCH_ALL_ENGAGEMENTS],
  getPromoterByType,
);

export const selectInstagramWelcomer = createSelector(
  [selectPromotersByBotId, _ => PromoterTypes.INSTAGRAM_WELCOMER],
  getPromoterByType,
);

export const selectInstagramStoryMentions = createSelector(
  [selectPromotersByBotId, _ => PromoterTypes.INSTAGRAM_STORY_MENTION],
  getPromoterByType,
);

export const selectInstagramStoryReactions = createSelector(
  [selectPromotersByBotId, _ => PromoterTypes.INSTAGRAM_STORY_REACTION],
  getPromoterByType,
);

export const selectInstagramCatchAllEnagagements = createSelector(
  [selectPromotersByBotId, _ => PromoterTypes.INSTAGRAM_CATCH_ALL_ENGAGEMENTS],
  getPromoterByType,
);

export const selectInstagramCommentGuards = createSelector(
  [selectPromotersByBotId, _ => PromoterTypes.INSTAGRAM_COMMENT_GUARD],
  getPromoterByType,
);

export const selectInstagramLive = createSelector(
  [selectPromotersByBotId, _ => PromoterTypes.INSTAGRAM_LIVE_COMMENT_GUARD],
  getPromoterByType,
);

export const selectCustomerChats = createSelector(
  [selectPromotersByBotId, _ => PromoterTypes.CUSTOMER_CHAT],
  getPromoterByType,
);

export const selectShareLinks = createSelector(
  [selectPromotersByBotId, _ => PromoterTypes.LINK],
  getPromoterByType,
);

export const selectInstagramShareLinks = createSelector(
  [selectPromotersByBotId, _ => PromoterTypes.INSTAGRAM_LINK],
  getPromoterByType,
);

export const selectOptinPopups = createSelector(
  [selectPromotersByBotId, _ => PromoterTypes.OPTIN],
  getPromoterByType,
);

export const selectMSKeywords = createSelector(
  [selectPromotersByBotId, _ => PromoterTypes.SMS_KEYWORDS],
  getPromoterByType,
);

export const selectGetemailsPromoters = createSelector(
  [selectPromotersByBotId, _ => PromoterTypes.GETEMAILS],
  getPromoterByType,
);

export const selectFacebookOptIns = createSelector(
  selectPromotersByBotId,
  promoters =>
    promoters.filter(({ type }) =>
      [PromoterTypes.CHECKBOX, PromoterTypes.MESSENGER].includes(type),
    ),
);

export const selectPromotersByType = createSelector(
  [selectPromotersByBotId, selectPromoterType],
  getPromoterByType,
);

export const selectPromoterById = createSelector(
  [selectPromoters, (_, id: number) => id],
  getPromoterById,
);
